import Vue from 'vue';
import ToolTipPanel from 'components/widgets/ToolTipPanel/ToolTipPanel.vue';
import ChartToolTipBody from 'components/widgets/ChartToolTipBody/ChartToolTipBody.vue';
import dayjs from 'dayjs';
import { roundValue } from "components/DataWidgets/KeyPhrases/KeyPhrases.utils";
import ChartUtils from "src/utils/chart";
export default Vue.extend({
    components: { ToolTipPanel, ChartToolTipBody },
    props: {
        showDrilldown: { type: Boolean, required: true },
        dataItem: { type: Object, required: true },
    },
    computed: {
        startDate() {
            return dayjs(this.customDates[0], 'DD/MM/YYYY').format('D MMM, YYYY');
        },
        endDate() {
            return dayjs(this.customDates[1], 'DD/MM/YYYY').format('D MMM, YYYY');
        },
        coverageDrilldown() {
            return ChartUtils.formatPercent((this.dataItem.coverage_pair_group ?? 0) * 100);
        },
        coverageOverall() {
            return ChartUtils.formatPercent((this.dataItem.coverage_pair ?? 0) * 100);
        },
        roundNpmi() {
            return roundValue(this.dataItem.npmi ?? 0);
        },
    },
});
